import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DialogData {
  title: string;
  message: string;
}

@Component({
  selector: 'app-async-dialog',
  templateUrl: 'async.dialog.component.html',
  styleUrls: ['async.dialog.component.scss']
})
export class AsyncDialogComponent implements OnInit {
  public result: any = false;

  constructor(
    public dialogRef: MatDialogRef<AsyncDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) { }

  onNoClick(): void {
    this.result = false;
    this.dialogRef.close(this.result);
  }

  onYesClick(): void {
    this.result = true;
    this.dialogRef.close(this.result);
  }

  ngOnInit() { }
}
